import { useEffect, useState } from 'react'

import IndexWidget, { LoadingIndexWidget } from './chart'
import { useSidebarIndexQuery } from '../../../store/api'
import type { IndexProps } from '../../../store/types/dashboard'

function IndexChart() {
  const { data, isLoading } = useSidebarIndexQuery()

  const [indexData, setIndexData] = useState<IndexProps>({
    index: '',
    dataset: [],
    average: '',
  })

  useEffect(() => {
    if (data) {
      setIndexData(data)
    }
  }, [data])

  return (
    <div className="sm:col-span-5">
      {isLoading ? (
        <LoadingIndexWidget compact />
      ) : (
        <IndexWidget
          average={indexData.average}
          dataset={indexData.dataset}
          index={indexData.index}
          compact
        />
      )}
    </div>
  )
}

export default IndexChart
